<template>
  <div class="select-reference-container">
    <label class="control-label">Mês de referência</label>
    <Select
      v-model="reference"
      :showOptionEmpty="false"
      :options="references"
    />
  </div>
</template>

<script>
import Select from '@/components/common/Select'

export default {
  components: {
    Select
  },
  props: {
    value: {
      type: Object
    }
  },
  created() {
    this.generateReferences()
    const { year, month } = this.value
    this.reference = `${year}${month}`
  },
  data() {
    return {
      references: [],
      reference: '',
      year: '',
      month: ''
    }
  },
  watch: {
    reference(value) {
      this.year = value.substr(0, 4)
      this.month = value.substr(4, 2)
      this.update()
    }
  },
  methods: {
    update() {
      const { year, month } = this
      this.$emit('input', { year, month })
    },
    generateReferences() {
      const currentYear = new Date().getFullYear()

      for (let index = 0; index < 12; index++) {
        const date = new Date(currentYear, index, 1)
        this.references.push({
          label: date.toLocaleString('pt-br', {
            month: 'long',
            year: 'numeric'
          }),
          value: `${currentYear}${date.toLocaleString('pt-BR', {
            month: '2-digit'
          })}`
        })
      }
    }
  }
}
</script>

<style scoped>
.select-reference-container {
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: #1a202c;
  font-family: BlinkMacSystemFont, -apple-system, Segoe UI, Roboto, Oxygen,
    Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, Helvetica, Arial,
    sans-serif;
  -webkit-font-smoothing: antialiased;
  margin-bottom: 5px;
}

.select-reference-container select {
  text-transform: capitalize;
}
</style>



// WEBPACK FOOTER //
// src/components/common/SelectReferenceDate.vue